export default __webpack_public_path__ + "static/media/AnimatedLogo.37058814.gif";